export enum SiteEventType {
    Unplanned_Unstaffed = "UnplannedUnstaffed",
    Guard = "Guard",
    Monitoring = "Monitoring",
    Information = "Information",
}
